import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber } from '../../../../helpers/custom-prop-types';
const SearchTitle = (props) => {
    const { total } = props;
    return (_jsxs("h2", Object.assign({ className: 'archive-title' }, { children: ["\u691C\u7D22\u7D50\u679C", _jsx("span", Object.assign({ className: 'font-number font-strong' }, { children: total })), _jsx("span", { children: "\u4EF6" })] })));
};
SearchTitle.propTypes = {
    total: propNumber().isRequired,
};
export default SearchTitle;
